import React, { useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Alert } from 'reactstrap';
import _get from 'lodash/get';

import { UiKit } from 'components';
import RetailerSelect from '../RetailerSelect';
import { localStore } from 'utils';
import { useForm, useMutation } from 'utils/hooks';
import { STORAGE_KEYS } from 'utils/DICTIONARY';
import { FORM_SCHEMA } from './stubs';

export default function StepTwo({
  email = '',
  retailers = [],
  loggedIn = () => {}
}) {
  const { replace } = useHistory();

  const [isError, setIsError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const passwordInputRef = useRef(null);

  const { data, errors, onChange, onValidate } = useForm({
    dataSchema: FORM_SCHEMA,
    defaultData: {
      email,
      password: '',
      retailerId: _get(retailers, '[0].options[0].value', null)
    }
  });

  const { mutate: login, isProcessing } = useMutation('auth.login', 'POST', {
    onSuccess: res => {
      replace('/login');
      loggedIn(_get(res, 'data', {}));
      localStore.put(STORAGE_KEYS.REFRESH_TOKEN, _get(res, 'refresh', ''));
    },
    onError: err => {
      const isNotified = _get(err, 'notified', false);
      const message = !isNotified
        ? _get(err, 'displayMessage.message')
        : 'Unable to login at this time. Please try again later.';
      setIsError(true);
      setErrorMessage(message);
    }
  });

  const onStoreSelect = value => {
    onChange({ retailerId: value });
    if (passwordInputRef.current) {
      passwordInputRef.current.focus();
    }
  };

  const onFormSubmit = e => {
    e.preventDefault();

    const isValid = onValidate(data);
    if (!isValid) return;

    setIsError(false);
    setErrorMessage('');
    login({
      username: data.email,
      password: data.password,
      retailer_id: data.retailerId
    });
  };

  return (
    <UiKit.Grid templateColumns="1fr" gap="16">
      <Alert
        color="danger"
        isOpen={isError}
        toggle={() => setIsError(false)}
        className="mb-0"
      >
        {errorMessage}
      </Alert>
      <form onSubmit={onFormSubmit}>
        <UiKit.Grid templateColumns="1fr" gap="16">
          <UiKit.Input
            disabled
            type="email"
            value={data.email}
            placeholder="Enter your email address"
            error={errors.email}
          />
          <RetailerSelect
            list={retailers}
            value={data.retailerId}
            onChange={onStoreSelect}
            error={errors.retailerId}
            isDisabled={isProcessing}
          />
          <UiKit.Input
            autoFocus
            data-private="lipsum"
            autoComplete="new-password"
            inputRef={passwordInputRef}
            type="password"
            value={data.password}
            onChange={value => onChange({ password: value })}
            disabled={isProcessing}
            placeholder="Password"
            error={errors.password}
          />
          <UiKit.Button className="w-100" processing={isProcessing}>
            Login
          </UiKit.Button>
        </UiKit.Grid>
      </form>
    </UiKit.Grid>
  );
}
